.layout {
  pointer-events: none;
  transition: opacity 0.25s ease-in-out 0.25s;
}

.productsRow {
  flex: 0 0 auto;
  pointer-events: auto;
  scrollbar-width: none;
}

.productsRow::-webkit-scrollbar {
  display: none;
}

@media all and (--reefer-media-desktop-md-min) {
  .brandLogo {
    width: 104px;
    height: 104px;
  }

  .brandName {
    font-size: var(--typography-h1-semibold-font-size-desktop);
    font-weight: var(--typography-h1-semibold-font-weight-desktop);
    line-height: var(--typography-h1-semibold-line-height-desktop);
    letter-spacing: var(--typography-h1-semibold-letter-spacing-desktop);
  }

  .tagline {
    font-size: var(--typography-h2-semibold-font-size-desktop);
    font-weight: var(--typography-h2-semibold-font-weight-desktop);
    line-height: var(--typography-h2-semibold-line-height-desktop);
    letter-spacing: var(--typography-h2-semibold-letter-spacing-desktop);
  }
}

/* The stack. */
@media all and (--reefer-media-desktop-sm-max) {
  .layout {
    flex-direction: column;
  }

  .brandBlock {
    flex-direction: column;
    align-items: normal;
    align-self: normal;
    gap: 12px;
  }

  .brandLogo {
    width: 48px;
    height: 48px;
  }

  .productsRow {
    align-items: normal;
    height: auto;
    gap: 12px;
    flex: initial;
    margin-right: -24px;
    padding-right: 24px;
    overflow-x: auto;
    overflow-y: hidden;
  }

  .brandText {
    gap: 0;
  }
}
